export const PLANNING_MODES = {
  OWN_FLEET: "OWN_FLEET",
  TENDER: "TENDER",
};

export const isTenderMode = (mode) => mode === PLANNING_MODES.TENDER;

export const getPlanningModeLabels = (mode) => {
  const tender = isTenderMode(mode);

  return {
    modeName: tender ? "Ausschreibung" : "Eigenfuhrpark",
    vehiclePlural: tender ? "Fahrzeugprofile" : "Busse",
    vehicleSingular: tender ? "Fahrzeugprofil" : "Bus",
    vehicleCapacity: tender ? "Profilkapazität" : "Buskapazität",
    vehicleNew: tender ? "Neues Fahrzeugprofil" : "Neuer Bus",
    vehicleName: tender ? "Profilname" : "Bus-Name",
    vehicleDeleteAll: tender ? "Alle Fahrzeugprofile löschen" : "Alle Busse löschen",
    vehicleDeletedAll: tender
      ? "Alle Fahrzeugprofile wurden gelöscht."
      : "Alle Busse wurden gelöscht.",
    vehicleDownload: tender ? "Profilliste wurde heruntergeladen." : "Busliste wurde heruntergeladen.",
    vehicleDownloadFailed: tender
      ? "Profilliste konnte nicht heruntergeladen werden."
      : "Busliste konnte nicht heruntergeladen werden.",
    depotLabel: tender ? "Depot-/Standortannahme" : "Depot-Adresse",
    countLabel: tender ? "Angelegte Fahrzeugprofile:" : "Angelegte Busse:",
    tableTotal: tender ? "Profilen" : "Bussen",
    routeVehicleId: tender ? "Profil-ID" : "Bus-ID",
    activeLabel: tender ? "Profil ist aktiv" : "Bus ist aktiv",
    notePlaceholder: tender
      ? "z. B. Annahme fuer Los A, Rollstuhlbus, Standort Landkreis Nord"
      : "z. B. Kindersitz liegt im Fahrzeug",
  };
};
